export function addCoverage(map, coverage) {
  if (map.current.getSource(`coverage-${coverage.id}`)) return;

  map.current.addSource(`coverage-${coverage.id}`, {
    type: "raster",
    scheme: "tms",
    tiles: [coverage.tilesUrl],
    minzoom: coverage.minZoom,
    maxzoom: coverage.maxZoom,
    tileSize: window.devicePixelRatio > 1 ? 128 : 256,
    attribution: coverage.attribution || "",
  });

  map.current.addLayer(
    {
      id: `coverage-layer-${coverage.id}`,
      type: "raster",
      source: `coverage-${coverage.id}`,
      layout: {
        visibility: "none",
      },
    },
    "satellite-Tunnel"
  );
}

export function loadCoverages(map, coverages) {
  if (coverages && coverages.length > 0) {
    coverages.forEach((coverage) => addCoverage(map, coverage));
  }
}
